export enum ManagementModelObjectParentTypes  {

	Route = "Route",
	Shipment = "Shipment",
	None = "None"
	
}
